export function isSupportPerformanceObserver() {
    return !!window.PerformanceObserver
}